import React, { useState } from 'react';
import axios from 'axios';

function LoginModal({ onLoginSuccess, openRegisterModal }) 
{
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const BASE_URL = process.env.NODE_ENV === 'production'
    ? (process.env.REACT_APP_IS_BETA === 'true' ? 'https://betaquotes.omntec.com' : 'https://quotes.omntec.com')
    : window.location.protocol === 'https:' 
        ? 'https://localhost:3001'
        : 'http://localhost:3001';


    const handleLogin = async () => 
    {
        try 
        {
            const response = await axios.post(
                `${BASE_URL}/api/login`, 
                { 
                    email: email.toLowerCase(), 
                    password 
                },
                { 
                    withCredentials: true 
                }
            );
            if (response.data.success)
            {
                onLoginSuccess(response.data.user); // Pass the user data to the onLoginSuccess function
            } 
            else 
            {
                setError('Invalid email or password.');
            }
        } 
        catch (err) 
        {
            setError('Something went wrong. Please try again.');
        }
    };

    // Key press handler for the Enter key
    const handleKeyPress = (e) => 
    {
        if (e.key === 'Enter') 
        {
            handleLogin();  // Trigger login on Enter key press
        }
    };

    return (
        <div className="modal">
            <div className="modal-content">
                <img src="/Logo-5.png" alt="Omntec Logo" className="modal-logo" />
                <h2 style={{color: "white"}}>Login</h2>
                <input 
                    type="email" 
                    placeholder="Email" 
                    value={email} 
                    onChange={(e) => setEmail(e.target.value.toLowerCase())} 
                    onKeyPress={handleKeyPress}
                />
                <input 
                    type="password" 
                    placeholder="Password" 
                    value={password} 
                    onChange={(e) => setPassword(e.target.value)}
                    onKeyPress={handleKeyPress}
                />
                {error && <p style={{ color: 'red' }}>{error}</p>}
                <button onClick={handleLogin}>Login</button>
                <p style={{color: "#726f6f"}}>Don't have a login? <span onClick={openRegisterModal} style={{ color: '#3e89ca', cursor: 'pointer' }}>Register Here</span></p>
            </div>
        </div>
    );
}

export default LoginModal;
